/** Default value for number of rows to display per page of Table.
 * @returns 10
 */
export const DEFAULT_TABLE_PAGESIZE: number = 10;

/**
 * Default message to display within table when filtering results with no rows to display within Table.
 * @returns 'No results found. Please try your search again.'
 */
export const DEFAULT_TABLE_SEARCH_NO_DATA_MESSAGE: string =
  'No results found. Please try your search again.';

/**
 * Default message to display within table when there are no rows to display within Table.
 * @returns "No data"
 */
export const DEFAULT_TABLE_NO_DATA_MESSAGE: string = 'No data';
